(function () {
  'use strict';

  if (window.PetsthingContentEnhancements) return;
  window.PetsthingContentEnhancements = true;

  var rootSelectors = [
    'body.hdt-page-type-article .hdt-article-content',
    'body.hdt-page-type-article .article-content',
    'body.hdt-page-type-page .hdt-page-content',
    'body.hdt-page-type-page .hdt-rte',
    'body.hdt-page-type-page .rte',
    'body.hdt-page-type-product .hdt-product-description',
    'body.hdt-page-type-product .hdt-product__description .hdt-rte',
    'body.hdt-page-type-product .hdt-full-des',
    'body.hdt-page-type-policy .shopify-policy__body'
  ];

  function each(list, callback) {
    Array.prototype.forEach.call(list, callback);
  }

  function removeCitationArtifacts(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(':contentReference') !== -1 || node.nodeValue.indexOf('oaicite') !== -1) {
        nodes.push(node);
      }
    }

    nodes.forEach(function (textNode) {
      textNode.nodeValue = textNode.nodeValue
        .replace(/【[\s\S]{0,160}:contentReference[\s\S]{0,160}?】/g, '')
        .replace(/【[\s\S]{0,120}oaicite[\s\S]{0,120}?】/g, '')
        .replace(/\s{2,}/g, ' ');
    });
  }

  function wrapTables(root) {
    each(root.querySelectorAll('table'), function (table) {
      if (table.closest('.petsthing-table-wrap')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'petsthing-table-wrap';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function closestToc(element) {
    return element.closest('nav, #toc, .toc-container, .petsthing-content-toc, .table-of-contents, .article-toc, [data-toc]');
  }

  function normalizeTocLinks(toc) {
    each(toc.querySelectorAll('a[href]'), function (link) {
      link.classList.remove('petsthing-content-btn', 'btn', 'btn-primary', 'bg-primary-color', 'text-white', 'px-6', 'py-3', 'rounded');
      link.classList.add('toc-link');
    });
  }

  function enhanceToc(root) {
    each(root.querySelectorAll('nav, #toc, .toc-container, .table-of-contents, .article-toc, [data-toc]'), function (toc) {
      var anchorLinks = toc.querySelectorAll('a[href^="#"]');
      var className = toc.className || '';

      if (toc.id === 'toc' || /(^|\s)(toc-container|table-of-contents|article-toc)(\s|$)/i.test(className) || anchorLinks.length >= 2) {
        toc.classList.add('petsthing-content-toc');
        normalizeTocLinks(toc);
      }
    });
  }

  function enhanceMedia(root) {
    each(root.querySelectorAll('img'), function (image) {
      if (!image.hasAttribute('loading')) image.setAttribute('loading', 'lazy');
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
    });
  }

  function isStandaloneLink(link) {
    var parent = link.parentElement;
    if (!parent || closestToc(link)) return false;

    var tagName = parent.tagName ? parent.tagName.toLowerCase() : '';
    if (['p', 'div', 'section', 'article', 'li'].indexOf(tagName) === -1) return false;

    var parentText = parent.textContent.replace(/\s+/g, ' ').trim();
    var linkText = link.textContent.replace(/\s+/g, ' ').trim();
    return linkText && (parentText === linkText || parent.children.length === 1);
  }

  function enhanceCtaLinks(root) {
    var ctaText = /(查看|了解|購買|選購|立即|查詢|聯絡|詳情|更多|whatsapp|shop|buy|learn|contact|details|more)/i;
    var shopTarget = /\/(collections|products|pages\/contact)|wa\.me|api\.whatsapp\.com/i;

    each(root.querySelectorAll('a[href]'), function (link) {
      if (link.className && /(^|\s)(hdt-btn|petsthing-content-btn)(\s|$)/.test(link.className)) return;
      if (!isStandaloneLink(link)) return;

      var href = link.getAttribute('href') || '';
      var text = link.textContent || '';
      if (ctaText.test(text) || shopTarget.test(href)) {
        link.classList.add('petsthing-content-btn');
      }
    });
  }

  function removeBodyMeta(root) {
    each(root.querySelectorAll('meta'), function (meta) {
      meta.parentNode.removeChild(meta);
    });
  }

  function enhanceRoot(root) {
    if (!root || root.classList.contains('petsthing-content-enhanced')) return;

    root.classList.add('petsthing-content-enhanced');
    removeBodyMeta(root);
    removeCitationArtifacts(root);
    wrapTables(root);
    enhanceToc(root);
    enhanceMedia(root);
    enhanceCtaLinks(root);
  }

  function normalizeStoreUrl(href) {
    var url;

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return '';
    }

    return 'https://petsthing.com.hk' + url.pathname.replace(/\/$/, '');
  }

  function getMetaContent(selector) {
    var meta = document.querySelector(selector);
    return meta ? (meta.getAttribute('content') || '').trim() : '';
  }

  function getCanonicalUrl() {
    var canonical = document.querySelector('link[rel="canonical"]');
    return canonical ? (canonical.getAttribute('href') || '').trim() : '';
  }

  function getCollectionName() {
    var heading = document.querySelector('h1, .hdt-main-heading h1, .hdt-heading, .collection-hero__title');
    var title = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';

    return title || getMetaContent('meta[property="og:title"]') || document.title.split(' – ')[0].trim() || document.title;
  }

  function isProductActionText(text) {
    return /^(加入|快速|add |quick |view |選項|缺貨|售罄|加入我的清單)/i.test(text);
  }

  function findProductImage(link) {
    var card = link.closest('.hdt-card-product, [class*="card-product"], [data-product-handle], .product, .product-inner, .pr_grid_item, li, article');
    var image = card ? card.querySelector('img') : null;
    var src = image ? (image.currentSrc || image.src || image.getAttribute('data-src') || image.getAttribute('data-original')) : '';

    if (!src) return '';

    try {
      return new URL(src, window.location.href).href;
    } catch (error) {
      return src.indexOf('//') === 0 ? 'https:' + src : src;
    }
  }

  function getCollectionProducts() {
    var products = [];
    var byUrl = {};
    var links = document.querySelectorAll('#MainContent a[href*="/products/"], main a[href*="/products/"]');

    each(links, function (link) {
      var url = normalizeStoreUrl(link.getAttribute('href') || '');
      var text = link.textContent.replace(/\s+/g, ' ').trim();
      var title = (link.getAttribute('title') || link.getAttribute('aria-label') || text).replace(/\s+/g, ' ').trim();

      if (!url || byUrl[url]) {
        if (url && text && !isProductActionText(text)) byUrl[url].item.name = byUrl[url].item.name || text;
        return;
      }

      byUrl[url] = {
        '@type': 'ListItem',
        position: products.length + 1,
        url: url,
        item: {
          '@type': 'Product',
          '@id': url + '#product',
          name: title && !isProductActionText(title) ? title : '',
          url: url
        }
      };

      var image = findProductImage(link);
      if (image) byUrl[url].item.image = image;

      products.push(byUrl[url]);
    });

    products.forEach(function (product) {
      if (product.item.name) return;

      var matchingLinks = document.querySelectorAll('a[href*="' + product.url.replace('https://petsthing.com.hk', '') + '"]');
      each(matchingLinks, function (link) {
        var text = link.textContent.replace(/\s+/g, ' ').trim();
        if (text && !isProductActionText(text)) product.item.name = text;
      });
    });

    return products.filter(function (product) {
      return product.item.name;
    }).slice(0, 12).map(function (product, index) {
      product.position = index + 1; delete product.item;
      return product;
    });
  }

  function injectCollectionSchema() {
    if (!document.body || !/hdt-page-type-collection|template-collection/.test(document.body.className)) return;
    if (document.getElementById('petsthing-collection-schema')) return;

    var collectionUrl = normalizeStoreUrl(getCanonicalUrl() || window.location.href);
    var products = getCollectionProducts();

    if (!collectionUrl || products.length === 0) return;

    var schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          '@id': collectionUrl + '#collectionpage',
          url: collectionUrl,
          name: getCollectionName(),
          description: getMetaContent('meta[name="description"]') || getMetaContent('meta[property="og:description"]') || getCollectionName(),
          inLanguage: document.documentElement.lang || 'zh-TW',
          isPartOf: {
            '@type': 'WebSite',
            '@id': 'https://petsthing.com.hk/#website',
            url: 'https://petsthing.com.hk/',
            name: 'Pets Thing'
          },
          publisher: {
            '@id': 'https://petsthing.com.hk/#organization'
          },
          mainEntity: {
            '@id': collectionUrl + '#itemlist'
          }
        },
        {
          '@type': 'ItemList',
          '@id': collectionUrl + '#itemlist',
          name: getCollectionName(),
          numberOfItems: products.length,
          itemListElement: products
        }
      ]
    };

    var script = document.createElement('script');
    script.id = 'petsthing-collection-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function scheduleCollectionSchemaInjection() {
    if (!document.body || !/hdt-page-type-collection|template-collection/.test(document.body.className)) return;

    var attempts = 0;
    var maxAttempts = 18;
    var timeoutId = null;
    var observer = null;

    function hasSchema() {
      return Boolean(document.getElementById('petsthing-collection-schema'));
    }

    function stop() {
      if (observer) observer.disconnect();
      if (timeoutId) window.clearTimeout(timeoutId);
      observer = null;
      timeoutId = null;
    }

    function queueTry(delay) {
      if (hasSchema() || attempts >= maxAttempts || timeoutId) return;

      timeoutId = window.setTimeout(function () {
        timeoutId = null;
        tryInject();
      }, delay);
    }

    function tryInject() {
      if (hasSchema()) {
        stop();
        return;
      }

      attempts += 1;
      injectCollectionSchema();

      if (hasSchema() || attempts >= maxAttempts) {
        stop();
        return;
      }

      queueTry(attempts < 5 ? 500 : 1500);
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        queueTry(250);
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(stop, 20000);
    }

    tryInject();
  }

  function init() {
    rootSelectors.forEach(function (selector) {
      each(document.querySelectorAll(selector), enhanceRoot);
    });
    scheduleCollectionSchemaInjection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
